import { Markets, Orderbook, User, Deposits, Withdrawals, Wallets, Currencies } from 'exchange-common'
import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { createStore, Store } from 'redux'
import { App } from './App'
import { ws } from './functions/ws'
import './index.css'
import { ColdWallets } from './models/coldWallets'
import { Dashboard } from './models/dashboard'
import { HotWallets } from './models/hotWallets'
import { Pendencies } from './models/pendencies'
import { IState } from './models/state'
import { reducers } from './reducers'
import registerServiceWorker from './registerServiceWorker'

const initialState: IState = {
	user: new User(),
	pendencies: new Pendencies(),
	dashboard: new Dashboard(),
	currencies: new Currencies(),
	custody: {},
	coldWallets: new ColdWallets(),
	hotWallets: new HotWallets(),
	users: [],
	admins: [],
	kyc: [],
	userDeposits: new Deposits(),
	userDetails: null,
	userOpenOrders: [],
	userOrdersHistory: [],
	userTrades: [],
	userWallets: new Wallets(),
	userWithdrawals: new Withdrawals(),
	kycDetails: null,
	deposits: [],
	depositDetails: null,
	withdrawals: [],
	withdrawDetails: null,
	tradeFees: [],
	withdrawFees: [],
	markets: new Markets(),
	orderbook: new Orderbook(),
	govBr: [],
}

export const store: Store<IState> = createStore(
	reducers,
	initialState,
	(window as any).__REDUX_DEVTOOLS_EXTENSION__ && (window as any).__REDUX_DEVTOOLS_EXTENSION__(),
)

ReactDOM.render(
	<Provider store={store}>
		<App />
	</Provider>,
	document.getElementById('root') as HTMLElement
)

registerServiceWorker()

ws.init()


// WEBPACK FOOTER //
// ./src/index.tsx